import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  FaClipboardList,
  FaClock,
  FaMapMarkerAlt,
  FaInfoCircle,
} from "react-icons/fa";
import BasicDetails from "./BasicDetails";
import DateTime from "./DateTime";
import Venue from "./Venue";
import Eventpolicies from "./Eventpolicies";
import { GetStatesData } from "../services/Webservices";
import axios from "axios";
import { localserver } from "../../../api/common";
import { showToast, ToastMessage } from "../../Shared/ToastMessage";
import { uploadFilesAWS } from "../../../api/Webservices";
import { useUser } from "../../AdminUsers/UserContext";
import { FaHome, FaChevronRight } from "react-icons/fa";
import {baseUrl} from '../../../api/common';
import { useEvent } from "../../Event/EventContext";

const EventInfo = () => {

  const { fetchEventDetails } = useEvent();
  const { checkPermission, getValidation } = useUser();
  const [errors, setErrors] = useState({
    eventName: "",
    description: "",
    eventUrlSlug: "",
    timeZone: "",
    venueName: "",
    venueCity: "",
    venueState: "",
    venueAddress: "",
    venuePincode: "",
    startDate: "", // ← NEW
    startTime: "", // ← NEW
  });
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [eventId, setEventId] = useState("");
  const [eventType, setEventType] = useState("");
  const [eventZone, setEventZone] = useState("");
  // Event basic details
  const [eventName, setEventName] = useState("");
  const [registrationTitle, setRegistrationTitle] = useState("");
  const [description, setDescription] = useState("");
  const [eventStatus, setEventStatus] = useState("draft");
  const [eventLogo, setEventLogo] = useState("");
  // Event mode selection
  const [eventMode, setEventMode] = useState("On-Site");
  const eventModeOptions = [
    {
      id: "Webinar",
      label: "Webinar",
      icon: <i className="fa fa-desktop"></i>,
    },
    {
      id: "On-Site",
      label: "On-Site",
      icon: <i className="fa fa-building-o"></i>,
    },
  ];
  const eventTypeList = [
    { id: 1, name: "Normal Event" },
    { id: 2, name: "Zonal Event" },
    { id: 3, name: "MMAS Event" },
    { id: 4, name: "FMAS Event" },
    { id: 5, name: "SLCP Event" },
  ];
  const AllzoneData = [
    {
      id: 1,
      value: "South Zone",
      states: [
        "Andhra Pradesh",
        "Telangana",
        "Karnataka",
        "Tamil Nadu",
        "Kerala",
        "Puducherry",
        "Lakshadweep",
      ],
    },
    {
      id: 2,
      value: "North Zone",
      states: [
        "Jammu and Kashmir",
        "Ladakh",
        "Himachal Pradesh",
        "Punjab",
        "Haryana",
        "Delhi",
        "Uttarakhand",
        "Uttar Pradesh",
        "Chandigarh",
      ],
    },
    {
      id: 3,
      value: "East Zone",
      states: [
        "Bihar",
        "Jharkhand",
        "Odisha",
        "West Bengal",
        "Sikkim",
        "Assam",
        "Arunachal Pradesh",
        "Meghalaya",
        "Manipur",
        "Mizoram",
        "Nagaland",
        "Tripura",
      ],
    },
    {
      id: 4,
      value: "West Zone",
      states: [
        "Rajasthan",
        "Gujarat",
        "Goa",
        "Maharashtra",
        "Dadra and Nagar Haveli and Daman and Diu",
      ],
    },
    {
      id: 5,
      value: "Central Zone",
      states: ["Madhya Pradesh", "Chhattisgarh", "Andaman and Nicobar Islands"],
    },
  ];
  // Event URL customization
  const DEFAULT_EVENT_URL = "https://eventz360.amasi.org";
  const [eventUrl, setEventUrl] = useState(baseUrl);
  const [isEditingUrl, setIsEditingUrl] = useState(false);
  const lastSlashIndex = eventUrl.lastIndexOf("/");
  const eventUrlBase = eventUrl.slice(0, lastSlashIndex + 1);
  const [eventUrlSlug, setEventUrlSlug] = useState("");
  const [eventDetailsUrl, setEventDetailsUrl] = useState("");
  // Streaming method
  const [streamingMethod, setStreamingMethod] = useState("RTMP");
  // Time zone and event time
  const [timeZone, setTimeZone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  // Venue details
  const [venueName, setVenueName] = useState("");
  const [venueCountry, setVenueCountry] = useState(101);
  const [venueCity, setVenueCity] = useState("");
  const [venueState, setVenueState] = useState("");
  const [venueAddress, setVenueAddress] = useState("");
  const [venuePincode, setVenuePincode] = useState("");
  const [mapLink, setMapLink] = useState("");
  const [tags, setTags] = useState("");
  const [venuePhoto, setVenuePhoto] = useState(null);
  const [isDetailedAddress, setIsDetailedAddress] = useState(false);
  // Image upload
  const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/jpg"];
  const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
  const [uploadedLogo, setUploadedLogo] = useState(null);
  const [uploadedVenuePhoto, setUploadedVenuePhoto] = useState(null);
  const [imageError, setImageError] = useState("");
  const [venueImageError, setVenueImageError] = useState("");
  // Country and state data
  const [countryData, setCountryData] = useState([]);
  const [stateList, setStateList] = useState([]);
  // Event policies
  const [policies, setPolicies] = useState([
    {
      id: 1,
      title: "Terms and Conditions",
      type: "url",
      content: "",
      file: null,
      imageUrl: null,
      characterCount: 20,
      maxCharacters: 40,
    },
    {
      id: 2,
      title: "Eg: Terms & Conditions",
      type: "text",
      content: "",
      file: null,
      imageUrl: null,
      characterCount: 0,
      maxCharacters: 40,
    },
  ]);
  const [policyError, setPolicyError] = useState("");
  const editorRefs = useRef({});
  const [eventData, setEventData] = useState({});
  const [activePage, setActivePage] = useState("basic");
  const topics = [
    {
      id: "basic",
      label: "Basic Details",
      icon: <FaClipboardList size={18} />,
      description: "Event name, description & logo",
    },
    {
      id: "date-time",
      label: "Date & Time",
      icon: <FaClock size={18} />,
      description: "Schedule & timezone settings",
    },
    {
      id: "venue",
      label: "Venue",
      icon: <FaMapMarkerAlt size={18} />,
      description: "Location & venue details",
    },
    {
      id: "event-details",
      label: "Event Policies",
      icon: <FaInfoCircle size={18} />,
      description: "Terms & conditions",
    },
  ];

  // JSX Methods for rendering different sections
  const renderHeader = () => (
    <div style={{ marginBottom: "22px" }}>
      <div className="brood_comes_div">
        <div className="row align-items-center">
          <div className="col-md-6 brood_comes_heading">
            <h2>
              <div className="brood_comes_part">
                <i className="fa fa-info-circle"></i>
              </div>
              Event Information
            </h2>
            {/* <nav aria-label="breadcrumb">
              <ol
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  fontSize: "14px",
                }} >
                <li>
                  <Link
                    to="/events/admin/"
                    style={{
                      color: "#6b7280",
                      textDecoration: "none",
                      transition: "color 0.2s ease",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#184778")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#6b7280")}
                  >
                    AMASI
                  </Link>
                </li>
                <li style={{ color: "#d1d5db" }}>
                  <FaChevronRight size={10} />
                </li>
                <li style={{ color: "#184778", fontWeight: "500" }}> Event Info</li>
              </ol>
            </nav> */}
          </div>
        </div>
      </div>
    </div>
  );

  const renderNavigationTabs = () => (
    <div style={{ marginBottom: "24px" }}>
      <div className="event_info_register">
        <div className="event_info_register_inner">
          {topics.map((topic) => (
            <button
              key={topic.id}
              className={`topic-button ${
                activePage === topic.id ? "active" : ""
              }`}
              onClick={() => setActivePage(topic.id)}
            >
              <div
                className={`topic-icon ${
                  activePage === topic.id ? "active" : ""
                }`}
              >
                {topic.icon}
              </div>
              <div className="topic-text">
                <span
                  className={`topic-title ${
                    activePage === topic.id ? "active" : ""
                  }`}
                >
                  {topic.label}
                </span>
                <span
                  className={`topic-description ${
                    activePage === topic.id ? "active" : ""
                  }`}
                >
                  {topic.description}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  const renderMainContent = () => (
    <div style={{ flex: 1 }}>
      <div className="innertabcontet_register">
        {activePage === "basic" && (
          <div style={{ padding: "15px 24px" }}>
            <div className="regis_tab_heading_content">
              <h2>Basic Details</h2>
              <p>
              Enter the essential details of your event, including name, logo,
              registration URL, and mode.
              </p>
            </div>
            <BasicDetails
              handleFileChange={handleFileChange}
              handleSaveEvent={handleSaveEvent}
              uploadedLogo={uploadedLogo}
              eventLogo={eventLogo}
              eventName={eventName}
              setEventName={setEventName}
              description={description}
              setDescription={setDescription}
              eventMode={eventMode}
              setEventMode={setEventMode}
              eventUrl={eventUrl}
              setEventUrl={setEventUrl}
              isEditingUrl={isEditingUrl}
              setIsEditingUrl={setIsEditingUrl}
              eventUrlBase={eventUrlBase}
              eventUrlSlug={eventUrlSlug}
              setEventUrlSlug={setEventUrlSlug}
              handleSaveUrl={handleSaveUrl}
              eventDetailsUrl={eventDetailsUrl}
              setEventDetailsUrl={setEventDetailsUrl}
              imageError={imageError}
              errors={errors}
              handleCopyUrl={handleCopyUrl}
              eventTypeList={eventTypeList}
              eventType={eventType}
              setEventType={setEventType}
              getValidation={getValidation}
            />
          </div>
        )}
        {activePage === "date-time" && (
          <div style={{ padding: "15px 24px" }}>
            <div className="regis_tab_heading_content">
              <h2>Date & Time</h2>
              <p>Set the schedule for your event, including the start and end dates, times, and time zones.</p>
            </div>
            <DateTime
              handleSaveEvent={handleSaveEvent}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              startTime={startTime}
              setStartTime={setStartTime}
              endTime={endTime}
              setEndTime={setEndTime}
              timezone={timeZone}
              setTimezone={setTimeZone}
              errors={errors}
              setErrors={setErrors}
              getValidation={getValidation}
            />
          </div>
        )}
        {activePage === "venue" && (
          <div style={{ padding: "15px 24px" }}>
            <div className="regis_tab_heading_content">
              <h2>Venue Details</h2>
              <p>Specify the location of your event, including the venue name, city, country, and any other relevant details.</p>
            </div>
            <Venue
              countryList={countryData}
              handleCountrydata={handleCountrydata}
              handleFileChange={handleFileChange}
              uploadedVenuePhoto={uploadedVenuePhoto}
              venuePhoto={venuePhoto}
              venueName={venueName}
              setVenueName={setVenueName}
              city={venueCity}
              setCity={setVenueCity}
              country={venueCountry}
              state={venueState}
              setState={setVenueState}
              handleStatedata={handleStatedata}
              stateList={stateList}
              venueAddress={venueAddress}
              setVenueAddress={setVenueAddress}
              venuePincode={venuePincode}
              setVenuePincode={setVenuePincode}
              venueGoogleMapLink={mapLink}
              setVenueGoogleMapLink={setMapLink}
              isDetailedAddress={isDetailedAddress}
              handleSaveEvent={handleSaveEvent}
              venueImageError={venueImageError}
              handleOpenDetailedAddress={handleOpenDetailedAddress}
              errors={errors}
              setErrors={setErrors}
              getValidation={getValidation}
            />
          </div>
        )}
        {activePage === "event-details" && (
          <div style={{ padding: "15px 24px" }}>
            <div className="regis_tab_heading_content">
              <h2>Event Policies</h2>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#6b7280",
                  margin: 0,
                  lineHeight: "1.5",
                }}
              >
                Define terms, conditions, and policies for your event
              </p>
            </div>
            <Eventpolicies
              policies={policies}
              setPolicies={setPolicies}
              error={policyError}
              setError={setPolicyError}
              editorRefs={editorRefs}
              getValidation={getValidation}
              handleTitleChange={(id, value) =>
                setPolicies(
                  policies.map((policy) =>
                    policy.id === id
                      ? {
                          ...policy,
                          title: value,
                          characterCount: value.length,
                        }
                      : policy
                  )
                )
              }
              handleTypeChange={(id, type) =>
                setPolicies(
                  policies.map((policy) =>
                    policy.id === id
                      ? {
                          ...policy,
                          type,
                          content: "",
                          file: null,
                          imageUrl: null,
                        }
                      : policy
                  )
                )
              }
              handleContentChange={(id, value) =>
                setPolicies(
                  policies.map((policy) =>
                    policy.id === id ? { ...policy, content: value } : policy
                  )
                )
              }
              addPolicy={() => {
                if (policies.length >= 3) {
                  setPolicyError("You can add up to 3 policies only.");
                  setTimeout(() => setPolicyError(""), 3000);
                  return;
                }
                setPolicies([
                  ...policies,
                  {
                    id: policies.length + 1,
                    title: "",
                    type: "text",
                    content: "",
                    file: null,
                    imageUrl: null,
                    characterCount: 0,
                    maxCharacters: 40,
                  },
                ]);
              }}
              deletePolicy={(id) => {
                setPolicies(policies.filter((policy) => policy.id !== id));
                setPolicyError("");
              }}
              handleSaveEvent={handleSaveEvent}
              validateImage={validateImage}
              uploadFilesAWS={uploadFilesAWS}
              showToast={showToast}
            />
          </div>
        )}
      </div>
    </div>
  );

  const getCountries = async () => {
    try {
      const response = await axios.get(`${localserver}/get_countries`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      if (response.data.success) {
        setCountryData(response.data.countries);
      } else {
        console.error("Error: Failed to fetch country data");
      }
    } catch (error) {
      console.error("Error fetching countries data:", error);
    }
  };

  const handleCountrydata = async (value) => {
    const countryId = String(value);
    setVenueCountry(countryId);
    if (countryId) {
      try {
        const response = await GetStatesData(countryId);
        setStateList(response);
      } catch (error) {
        console.error("Error fetching states:", error);
        setStateList([]);
      }
    } else {
      setStateList([]);
    }
  };

  const handleStatedata = async (value) => {
    const stateId = Number(value);
    setVenueState(stateId);
    const selectedState = stateList.find((state) => state.id === stateId);
    if (selectedState) {
      try {
        const foundZone = AllzoneData.find(
          (zone) =>
            Array.isArray(zone.states) &&
            zone.states.includes(selectedState.name)
        );
        if (foundZone) {
          setEventZone(foundZone.value);
        } else {
          setEventZone("");
        }
      } catch (error) {
        console.error("Error finding zone:", error);
      }
    }
  };

  const handleSaveUrl = () => {
    setEventUrl(eventUrlBase + eventUrlSlug);
    setIsEditingUrl(false);
    setErrors((prev) => ({ ...prev, eventUrlSlug: "" }));
  };

  const handleOpenDetailedAddress = (status) => {
    setVenueState(eventData.state_id);
    setIsDetailedAddress(status);
  };

  const MIN_DIMENSION = 90;
  const MAX_DIMENSION = 160;
  const validateImage = (file, type) => {
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      return `${
        type === "logo" ? "Event logo" : "Venue photo"
      } must be JPG, JPEG, or PNG format.`;
    }
    if (file.size > MAX_IMAGE_SIZE) {
      return `${
        type === "logo" ? "Event logo" : "Venue photo"
      } size must not exceed 5MB.`;
    }
    return new Promise((resolve) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.onload = () => {
        const isWidthValid =
          img.width >= MIN_DIMENSION && img.width <= MAX_DIMENSION;
        const isHeightValid =
          img.height >= MIN_DIMENSION && img.height <= MAX_DIMENSION;
        if (
          !(isWidthValid && isHeightValid) ||
          (img.width !== 150 &&
            img.height !== 100 &&
            img.width !== 100 &&
            img.height !== 150)
        ) {
          URL.revokeObjectURL(objectUrl);
          resolve(
            `${
              type === "logo" ? "Event logo" : "Venue photo"
            } dimensions must be approximately 150 × 100 or 100 × 150 pixels (within 90-160 × 90-160).`
          );
        } else {
          URL.revokeObjectURL(objectUrl);
          resolve(null);
        }
      };
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        resolve(
          `Failed to load ${
            type === "logo" ? "event logo" : "venue photo"
          }. Please try again.`
        );
      };
      img.src = objectUrl;
    });
  };

  const handleFileChange = (type) => async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const validationError = await validateImage(file, type);
    if (validationError) {
      if (type === "logo") {
        setImageError(validationError);
      } else {
        setVenueImageError(validationError);
      }
      return;
    }
    try {
      const res = await uploadFilesAWS({ upload_files: file });
      if (res.data && res.data.success === true) {
        const uploadedUrl = res.data.uploadedUrls.upload_files[0];
        if (type === "logo") {
          setEventLogo(uploadedUrl);
          setUploadedLogo(URL.createObjectURL(file));
          setImageError("");
        } else {
          setVenuePhoto(uploadedUrl);
          setUploadedVenuePhoto(URL.createObjectURL(file));
          setVenueImageError("");
        }
        await handleSaveEvent(uploadedUrl, type);
      } else {
        showToast(res.message, "error");
      }
    } catch (error) {
      console.error(`Error uploading ${type}:`, error);
      showToast(`Failed to upload ${type}. Please try again.`, "error");
    }
  };

  const removeImage = (type) => () => {
    if (type === "logo") {
      setUploadedLogo(null);
      setEventLogo(null);
    } else {
      setUploadedVenuePhoto(null);
      setVenuePhoto(null);
    }
  };

  const parseTimeString = (timeStr) => {
    if (!timeStr) return null;
    const [hours, minutes, seconds] = timeStr.split(":");
    const now = new Date();
    now.setHours(Number(hours), Number(minutes), Number(seconds || 0), 0);
    return now;
  };

  const formatTime = (date) => {
    if (!date) return null;
    return new Date(date).toTimeString().slice(0, 8);
  };

  const formatDateTime = (date, time) => {
    if (!date || !time) return null;
    return `${new Date(date).toISOString().slice(0, 10)} ${new Date(
      `2025-01-01T${time}`
    )
      .toTimeString()
      .slice(0, 8)}`;
  };

  const validateStep = () => {
    const newErrors = {};
    let isValid = true;

    if (activePage === "basic") {
      if (!eventName.trim()) {
        newErrors.eventName = "Event name is required";
        isValid = false;
      }
    } else if (activePage === "date-time") {
      if (!startDate) {
        newErrors.startDate = "Start date is required";
        isValid = false;
      }
      if (!startTime) {
        newErrors.startTime = "Start time is required";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSaveEvent = async (logoUrl = "", type) => {
    // Validate current tab before saving
    if (!validateStep()) {
      showToast("Please fill all required fields.", "error");
      return;
    }

    const hasPermission = await checkPermission("Event Info", "update");
    if (!hasPermission) return;

    setIsLoading(true);
    setApiError("");

    const eventLogoUrl = type === "logo" ? logoUrl : eventLogo;
    const venuePhotoUrl = type === "venue" ? logoUrl : venuePhoto;

    const event_policy = policies.map((policy) => ({
      policy_title: policy.title,
      format: policy.type,
      value: policy.type === "document" ? policy.content : policy.content,
      imageUrl: policy.imageUrl || "",
    }));

    const eventData = {
      event_id: eventId,
      event_basic_details: {
        event_name: eventName,
        registration_title: registrationTitle,
        registration_url: eventUrl,
        description,
        event_logo: eventLogoUrl || "",
        event_status: eventStatus,
        is_zonal: eventType - 1,
        zone: eventZone || null,
        event_details_url:eventDetailsUrl || ""
      },
      venue_details: {
        time_zone: timeZone,
        venue: venueName || "Virtual Venue",
        tags: tags || "",
        venue_name: venueName || "",
        venue_photo: venuePhotoUrl || "",
        venue_city: venueCity || "",
        venue_state: venueState || "",
        venue_address: venueAddress || "",
        venue_pincode: venuePincode || "",
        map_link: mapLink || "",
        state_id: venueState,
        country_id: venueCountry,
      },
      event_types: {
        event_type: eventMode,
        streaming_method: streamingMethod,
      },
      event_time: {
        start_date: new Date(startDate).toISOString().slice(0, 10) || null,
        end_date: new Date(endDate).toISOString().slice(0, 10) || null,
        start_time: formatTime(startTime),
        end_time: formatTime(endTime),
        event_date: formatDateTime(startDate, formatTime(startTime)),
      },
      event_policy,
    };

    try {
      const response = await axios.post(
        `${localserver}/update_event_details`,
        eventData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.success) {
        showToast(response.data.message, "success");
        getValidation();
        fetchEventDetails(localStorage.getItem("eventId"));
      } else {
        throw new Error(response.data.message || "Failed to save event");
      }
    } catch (error) {
      setApiError(error.message || "An error occurred while saving the event.");
      showToast(
        error.message || "An error occurred while saving the event.",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const getEventById = async (event_id) => {
    try {
      const response = await axios.post(
        `${localserver}/get_event_details_by_event_id`,
        { event_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.success) {
        getValidation()
        const event = response.data.event;
        setEventData(event);
        setEventId(event.id);
        setEventName(event.event_name);
        setEventType(Number.parseInt(event.is_zonal) + 1);
        setEventZone(event.zone);
        setDescription(event.description);
        setEventLogo(event.event_logo);
        setEventUrl(event.registration_url);
        setEventMode(event.event_type);
        const lastSlashIndex = event.registration_url.lastIndexOf("/");
        const eventUrlBase = event.registration_url.slice(lastSlashIndex + 1);
        setEventUrlSlug(eventUrlBase);
        setEventStatus(event.event_status);
        setRegistrationTitle(event.registration_title);
        setStartDate(event.start_date ? new Date(event.start_date) : null);
        setEndDate(event.end_date ? new Date(event.end_date) : null);
        setStartTime(parseTimeString(event.start_time));
        setEndTime(parseTimeString(event.end_time));
        setPolicies(
          event.event_policy
            ? JSON.parse(event.event_policy).map((policy, index) => ({
                id: index + 1,
                title: policy.policy_title,
                type: policy.format,
                content: policy.value,
                file: null,
                imageUrl: policy.imageUrl || null,
                characterCount: policy.policy_title.length,
                maxCharacters: 40,
              }))
            : [
                {
                  id: 1,
                  title: "Terms and Conditions",
                  type: "url",
                  content: "",
                  file: null,
                  imageUrl: null,
                  characterCount: 20,
                  maxCharacters: 40,
                },
                {
                  id: 2,
                  title: "Eg: Terms & Conditions",
                  type: "text",
                  content: "",
                  file: null,
                  imageUrl: null,
                  characterCount: 0,
                  maxCharacters: 40,
                },
              ]
        );
        setVenueName(event.venue_name);
        setVenueCity(event.venue_city);
        setVenueState(event.state_id);
        setVenueCountry(event.country_id || 101);
        setVenueAddress(event.venue_address);
        setVenuePincode(event.venue_pincode);
        setMapLink(event.map_link);
        setTags(event.tags);
        setVenuePhoto(event.venue_photo);
        setUploadedLogo(event.event_logo);
        setUploadedVenuePhoto(event.venue_photo);
        setStreamingMethod(event.streaming_method);
        setTimeZone(event.time_zone);
        setEventDetailsUrl(event.event_details_url||"")
      } else {
        console.error("Error: Failed to fetch event data");
      }
    } catch (error) {
      console.error("Error fetching event data:", error);
    }
  };

  const handleCopyUrl = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      showToast("Event URL Copied", "success");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const [checkUserLoading, setCheckUserLoading] = useState(false);
  const fetchPermission = async () => {
    setCheckUserLoading(true);
    try {
      const hasPermission = await checkPermission("Event Info", "view");
      if (!hasPermission) return;
    } catch (error) {
      console.error("Error Check Permission:", error);
    } finally {
      setCheckUserLoading(false);
    }
  };

  useEffect(() => {
    fetchPermission();
  }, []);

  useEffect(() => {
    const eventId = localStorage.getItem("eventId");
    if (eventId) {
      getEventById(eventId);
    }
    getCountries();
  }, []);

  useEffect(() => {
    if (venueCountry) {
      handleCountrydata(venueCountry);
    }
  }, [venueCountry]);

  return (
    <>
      {checkUserLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "500px" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div
          style={{
            minHeight: "100vh",
            backgroundColor: "#f8fafc",
            padding: "24px 15px",
          }}
        >
          <ToastMessage />
          {renderHeader()}
          {renderNavigationTabs()}
          <div
            style={{ display: "flex", gap: "24px", alignItems: "flex-start" }}
          >
            {renderMainContent()}
          </div>
        </div>
      )}
    </>
  );
};

export default EventInfo;
